import TagBox from "devextreme/ui/tag_box";
import { useSelector } from "react-redux";
import { ProaFormFFRRPresenterExtension } from "@presenters/screens/form-proa-ffrr-extension.presenter";
import { IFormProa } from "@interfaces/screens/form-proa.interface";
import {
  ICmdSpfrStep4Update,
  ISpfrStep4LineaBase,
  IDtoSpfrStep4BaseLine,
  ISpfrStep4LineaBaseAnios,
  IProaFormBasicDataMasters,
  ILang,
  ICmdSpfrStep2Update,
  ICmdSpfrStepSDCUpdate,
  ISpfrStep1Anio,
  ISpfrStep2Anio,
  ISpfrStepSDCAnio,
  ISpfrStep1Beneficiary,
  IDtoStep2,
  IDtoStepSDC,
  ICmdSpfrStep1,
  ISpfrStep2,
  ISpfrStepSDC,
  ICmdSpfrStep3Update,
  IDtoAdtZonaSave,
  ISpfrStep3Anios,
  ISpfrStep3,
  IDtoGetStep4,
  IDtoSpfrStep4Products,
  IStep5ProductDataDto,
  ISpfrStep4ProductosAnios,
  IFileDto,
  ICmdSpfrStep4,
  ISpfrStep4Productos,
} from "@models/*";
import {
  ProaService,
  IProaService,
} from "@services/proyecta/proa-form.service";
import { SPFRRService, ISPFRRService } from "@services/proyecta/spfrr.service";
import DataGrid from "devextreme/ui/data_grid";
import {
  Utilities,
  moment,
  Enums,
  Dictionary,
  Constants,
  String,
  queryString,
  GridUtilities,
  IDataTable,
} from "@utils";
import { AEAFieldProps } from "@/components/ui/aea-field/aea-field";
import { BatchGridColumnProps } from "@/components/ui/aea-batch-grid/aea-batch-grid";

export class MainProaSubprojectFFRRPresenter extends ProaFormFFRRPresenterExtension {
  public params: any;
  public currentBudget: any;
  public currentBudgetStartDate: any;
  public currentBudgetDetails:any;
  public currentLabels: Dictionary<string, string>;
  public formMasters: IProaFormBasicDataMasters;
  public currentLang: ILang;
  public completedLoad: boolean;
  public progress: number;
  protected proaService: IProaService;
  protected startDateRestriction: any;
  protected SPFRService: ISPFRRService;

  constructor(view: IFormProa) { 
    super(view);
    this.params = useSelector(this.context.sessionStore.selectParams);
    this.currentBudget = useSelector( this.context.proaStore.selectCurrentBudget) as any;
    this.currentBudgetDetails = useSelector( this.context.proaStore.selectCurrentBudgetDetails) as any;
    this.currentLabels = useSelector( this.context.sessionStore.selectLabels) as any;
    this.formMasters = useSelector( this.context.proaStore.selectFormMasters) as any;
    this.currentLang = useSelector(this.context.sessionStore.selectLang) as any;
    this.currentBudgetStartDate = useSelector( this.context.proaStore.selectCurrentBudgetStartDate) as any;
    this.progress = useSelector(this.context.sessionStore.selectProgress);
    this.SPFRService = new SPFRRService();
    this.proaService = new ProaService();
    this.startDateRestriction = null;
    this.completedLoad = false;
    this.addFile = this.addFile.bind(this);
    this.openCloseModal = this.openCloseModal.bind(this);
    this.onCellPreRender = this.onCellPreRender.bind(this);
    this.openCloseModalExcel = this.openCloseModalExcel.bind(this);
    this.getSummaryValue = this.getSummaryValue.bind(this);
    this.onCellPreRenderMri = this.onCellPreRenderMri.bind(this);
    this.checkConsolidateADT = this.checkConsolidateADT.bind(this);
    this.checkConsolidateValues = this.checkConsolidateValues.bind(this);
    this.handleChangeValue = this.handleChangeValue.bind(this);
    this.checkRequiredFields = this.checkRequiredFields.bind(this);
    this.checkEndDate = this.checkEndDate.bind(this);
  }
  private getCommonFieldProps(fieldName: string) {
    const fieldProps = this.view.state.dataColumns.get(fieldName);
    const field: AEAFieldProps = {
      showLabel: true,
      title: fieldProps?.NombreColumna || "",
      description: fieldProps?.OCTAVIATooltip || "",
      id: `${fieldProps?.Id || 0}_ffrr`,
      placeholder: fieldProps?.NombreColumna || "",
      fieldType: fieldProps?.TipoCampoProyecta || "text",
      requiredErrorMessage: "campo obligatorio",
      required: true,
      multiple: fieldProps?.OCTAVIAMultiple,
    };
    if (fieldName === Enums.ProaBasicFields.IntermediateResult) {
      const intLine = this.currentBudget.OCTAVIALineaIntervencionId;
      const iLE = this.formMasters.strategicLines.find((x: any) => x.PRGCodigoLineaIntervencionId === intLine);
      const data = this.formMasters?.intermediateResults.filter((x: any) => x.PFFRRCodigoIndicadorLineaInterveId === iLE.Id);
      field.items = Utilities.processDropDownData(data,Enums.ListTypes.IntermediateResult);
    }
    if (fieldName === Enums.ProaBasicFields.IndicatorIntermediateResult) {
      if (!Utilities.isNullEmptyObject(this.view.state.intermediateResults)) {
        const intResult = this.view.state.intermediateResults[0];
        const data = this.formMasters?.intermediateResultsIndicator.filter(
          (x: any) => x.PFFRRCodigoResultadoIntermedioId === intResult
        );
        field.items = Utilities.processDropDownData(data,Enums.ListTypes.IntermediateIndicatorResults);
      } else {
        field.items = [];
      }
    }
    field.readOnly = this.view.state.readOnly ? this.view.state.readOnly : field.readOnly;
    return field;
  }

  //#region init Form
  public getReadOnly() {
    const readOnly: boolean = window.location.href.indexOf("view?Id") > -1;
    this.view.state.setReadOnly(readOnly);
    return readOnly;
  }
  private getBudgetId() {
    const query = queryString.parseUrl(window.location.href.replace("#", ""))
      .query as any;
    return query.Id;
  }
  public unSetLoading() {
    this.dispatcherUnsetSetLoading();
  }
  private async getSpfrStep1() {
    return await this.SPFRService.getStepOne({ budgetId: this.getBudgetId() });
  }
  private async getSpfrStep2() {
    return await this.SPFRService.getStepTwo({ budgetId: this.getBudgetId() });
  }
  private async getSpfrStep3() {
    return await this.SPFRService.getStepThree({ budgetId: this.getBudgetId() });
  }
  private async getSpfrStepSDC() {
    return await this.SPFRService.getSDCStep({ budgetId: this.getBudgetId() });
  }
  
  public get isContentReady() {
    return (
      !Utilities.isNullEmptyObject(this.currentBudget) &&
      !Utilities.isNullEmptyObject(this.currentLabels) &&
      !Utilities.isNullEmptyObject(this.formMasters) &&
      !Utilities.isNullEmptyObject(this.currentLang)
    );
  }

  public async initStep1() {
    const step1 = await this.getSpfrStep1();
    const startDate = step1?.genericInfo.OCTAVIAFechaInicio;    
    this.syncDispatcher(this.context.proaStore.actions.setCurrentBudgetStartDate(Utilities.getDateEuropeTimeZone(startDate as Date)));
    this.view.setStep1(step1); 
  }
  
  //#endregion
  /*************************************************************************************** */
  //#region Header
  public async initializeHeaderInformation() {
    if (this.isContentReady) {
      let header = await this.getHeaderInformation()
      this.view.state.setHeaderInfo(header);
    }
  }
  private async getHeaderInformation() {

    const data = await this.SPFRService.getHeader({
      budgetId: this.currentBudget.Id,
      langLabel: this.currentLang.label,
    });
    
    const headerInformation = [
      { label: "Titulo de proyecto", value: data.projectTitle },
      { label: "Codigo proyecto", value: data.projectCode },
      { label: "Financiador", value: data.financier },
      { label: "Objetivo estrategico", value: data.strategicObjetive },
      { label: "Linea estrategica", value: data.strategicLine },
    ];

    return Promise.resolve(headerInformation);
  }
  //#endregion
  /********************************************* */
  //#region Step1
  /******************** */
  //#region dates
  public get initDate() {
    if (this.view.baseLineData?.length > 0) {      
      if (!Utilities.isNullEmptyObject(this.currentBudgetStartDate)) {
        const startDate = this.currentBudgetStartDate;        
        const min = "01/01/" + moment.utc(new Date(startDate)).tz(Constants.GeneralFormats.TIME_ZONE).format("DD-MM-YYYY").substr(-4);
        const max = "12/31/" + moment.utc(new Date(startDate)).tz(Constants.GeneralFormats.TIME_ZONE).format("DD-MM-YYYY").substr(-4);
        this.startDateRestriction = { min: new Date(min), max: new Date(max) };
      }
    }
    const field = {
      ...this.getCommonFieldProps(Enums.ProaBasicFields.FechaInicio),
      onValueChanged: (data: any) => {
        const startDate = data;
        this.syncDispatcher(
          this.context.proaStore.actions.setCurrentBudgetStartDate(startDate)
        );
      },
      minDate: this.startDateRestriction ? this.startDateRestriction.min : null,
      maxDate: this.startDateRestriction ? this.startDateRestriction.max : null,
      value: this.currentBudgetStartDate
    };    
    return field;
  }

  public get endDate() {    
    const endDate = this.view.state.endDate != null && this.view.state.endDate != undefined ? typeof this.view.state.endDate === "string" ? this.view.state.endDate : this.view.state.endDate.toUTCString() : null;
    const oc_endDate = this.view.genericData?.OCTAVIAFechaFinalizacion != null && this.view.genericData?.OCTAVIAFechaFinalizacion != undefined ? 
      typeof this.view.genericData.OCTAVIAFechaFinalizacion === "string" ? this.view.genericData.OCTAVIAFechaFinalizacion : this.view.genericData.OCTAVIAFechaFinalizacion.toUTCString() : null;
    
      const field = {
      ...this.getCommonFieldProps(Enums.ProaBasicFields.FechaFin),
      onValueChanged: (data: any) => {        
        const endDate = data;
        this.view.state.setEndDate(endDate);
      },
      minDate: this.currentBudgetStartDate,
      value:  endDate !== null 
        ? endDate 
        : oc_endDate != null 
          ? oc_endDate 
          : null        
    };
    return field;
  }

  public checkConsolidateValues(item: any, tableData2: any, withMessage: boolean = false) {
    
    let totalTable2: any = Object.keys(tableData2)?.find((x: any) => !x.includes(Enums.ProaBasicFields.MetaValor))
    let currentKeys: any = Object.keys(item)
    let message: any = null

    let columnIds = currentKeys.map((_key: any, index: number) => {
      if(_key.includes(Enums.ProaBasicFields.MetaValor)){
        if(Number(item[_key]?.toFixed?.(2)) !== Number(tableData2?.[_key]?.toFixed?.(2))) return index
      }else if(Number(item[_key]?.toFixed?.(2)) !== Number(tableData2?.[totalTable2]?.toFixed?.(2))) return index
    })

    columnIds = columnIds.filter((x: any) => (!Utilities.isNullEmptyObject(x) && x >= 0))
    if(columnIds?.length && withMessage){
      message = this.currentLabels.get("AlertConsolidateValuesWithoutLoc")
    }

    return { columnIds, message }
  }

  public checkConsolidateADT(adtData: any, impData: any, locData: any, actData: any, withMessage: boolean = false) {
    let totalImp: any = Object.keys(impData)?.find((x: any) => !x.includes(Enums.ProaBasicFields.MetaValor))
    let totalLoc: any = Object.keys(locData)?.find((x: any) => !x.includes(Enums.ProaBasicFields.MetaValor))
    let totalAct: any = Object.keys(actData)?.find((x: any) => !x.includes(Enums.ProaBasicFields.MetaValor))
    let currentKeys: any = Object.keys(adtData)
    let message: any = null
    let thereLoc: boolean = false

    let columnIds = currentKeys.map((_key: any, index: number) => {
      if(!thereLoc) thereLoc = (!!locData?.[_key] || !!locData?.[totalLoc])
      if(_key.includes(Enums.ProaBasicFields.MetaValor)){
        if(Number(adtData[_key]?.toFixed?.(2)) > Number(impData?.[_key]?.toFixed?.(2)) || 
          (!!locData?.[_key] && Number(adtData[_key]?.toFixed?.(2)) > Number(locData?.[_key]?.toFixed?.(2))) ||
          Number(adtData[_key]?.toFixed?.(2)) > Number(actData?.[_key]?.toFixed?.(2))) return index
      }else if(Number(adtData[_key]?.toFixed?.(2)) > Number(impData?.[totalImp]?.toFixed?.(2)) ||
         (!!locData?.[totalLoc] && Number(adtData[_key]?.toFixed?.(2)) > Number(locData?.[totalLoc]?.toFixed?.(2))) ||
         Number(adtData[_key]?.toFixed?.(2)) > Number(actData?.[totalAct]?.toFixed?.(2))) return index
    })

    columnIds = columnIds.filter((x: any) => (!Utilities.isNullEmptyObject(x) && x >= 0))
    if(columnIds?.length && withMessage){
      if(thereLoc) message = this.currentLabels.get("AlertConsolidateAdt")
      else message = this.currentLabels.get("AlertConsolidateAdtWithoutLoc")
    }

    return { columnIds, message }
  }

  public checkRequiredFields(columns: any, item: any) {
    let message: any = null

    let columnIds = columns.map((x: any) => {
      let field = x.dataField
      if(field === Enums.ProaBasicFields.PProaMedidaId || field === Enums.ProaBasicFields.MetaFinal || field?.includes(Enums.ProaBasicFields.MetaValor)){
        let value = Array.isArray(item[field]) ? item[field]?.[0] : item[field]
        
        if(!value && value !== 0){
         message = this.currentLabels.get("AlertReqFields")
          return x.visibleIndex
        }
      }
    })
    
    columnIds = columnIds.filter((x: any) => x >= 0)

    return { columnIds, message }
  }

  public checkEndDate(columns: any, item: any) {
    let message: any = null
    const endYear = this.view.state.endDate ? new Date(this.view.state.endDate).getFullYear() : null;

    let columnIds = columns.map((x: any) => {
      let field = x.dataField
      if(field?.includes(Enums.ProaBasicFields.MetaValor)){
        let year = field?.split("-")?.[1] ? Number(field.split("-")[1]) : null
        if(!!year && year > endYear) return x.visibleIndex;
      }else if(field === Enums.ProaBasicFields.BeneficiarioAnio){
        let year = item[Enums.ProaBasicFields.BeneficiarioAnio] ? Number(item[Enums.ProaBasicFields.BeneficiarioAnio]) : null
        if(!!year && year > endYear) return x.visibleIndex;
      }
    })

    columnIds = columnIds.filter((x: any) => x >= 0)

    return { columnIds, message }
  }

  public handleChangeValue(option: any) {
    let message = null
    if(!!option?.data || !!option?.data?.__KEY__){
      let field = option?.dataField
      let value = option.data[field]
      if((field?.includes(Enums.ProaBasicFields.MetaValor) || field === Enums.ProaBasicFields.MetaFinal) && value >= 0){
        let dataKeys: any = Object.keys(option.data) || []
        let isMultiYear = dataKeys.filter((x: any) => x?.includes(Enums.ProaBasicFields.MetaValor))?.length > 1
        if(value === 0) 
          message = this.currentLabels.get("ToastGoalCero")
        else if(value <= option.data[Enums.ProaBasicFields.LineaBase] && option.data[Enums.ProaBasicFields.LineaBase] !== undefined)
          message = this.currentLabels.get("ToastGoalBaseLine")
        else if(isMultiYear && field?.includes(Enums.ProaBasicFields.MetaValor)){
          if(value === option.data[Enums.ProaBasicFields.MetaFinal]) message = this.currentLabels.get("ToastYearGoal")
        }
      }
      
    }
    return message
  }

  public validEndDate() {
    let valid = true
    const endYear = this.view.state.endDate ? new Date(this.view.state.endDate).getFullYear() : null;
    if(Utilities.isNullEmptyObject(endYear)) return valid;

    let step1Data = this.view.step1Data
    let step2Data = this.view.step2Data
    let stepSDCData = this.view.stepSDCData
    let step3Data = this.view.step3Data
    let step4MRIData = this.view.step4MRIData
    let step4Data = this.view.step4Data

    if(!Utilities.isNullEmptyObject(step1Data) && valid){
      step1Data?.baseLineYears?.forEach((year: any) => { if(Number(year?.PPresAnioMeta) > endYear) valid = false})
      step1Data?.beneficiaries?.forEach((year: any) => { if(Number(year?.PPresuAnio) > endYear) valid = false})
    }

    if(!Utilities.isNullEmptyObject(step2Data) && valid){
      step2Data?.genericInfo?.[0]?.implementerYears?.forEach((year: any) => { if(Number(year?.PPresAnioMeta) > endYear) valid = false})
    }

    if(!Utilities.isNullEmptyObject(stepSDCData) && valid){
      stepSDCData?.genericInfo?.[0]?.counterpartsYears?.forEach((year: any) => { if(Number(year?.PPresAnioMeta) > endYear) valid = false})
    }

    if(!Utilities.isNullEmptyObject(step3Data) && valid){
      step3Data?.adts?.[0]?.details?.forEach((year: any) => { if(Number(year?.PPresAnioMeta) > endYear) valid = false})
      step3Data?.zones?.[0]?.details?.forEach((year: any) => { if(Number(year?.PPresAnioMeta) > endYear) valid = false})
    }

    if(!Utilities.isNullEmptyObject(step4MRIData) && valid){
      step4MRIData?.[0]?.years?.forEach((year: any) => { if(Number(year?.PPresAnioMeta) > endYear) valid = false})
    }

    if(!Utilities.isNullEmptyObject(step4Data) && valid){
      for (const step4 of step4Data) {
        step4?.objetives?.[0]?.years?.forEach((year: any) => { if(Number(year?.PPresAnioMeta) > endYear) valid = false})
        let results = step4?.results || []
        for (const res of results) {
          res?.activities?.[0]?.years?.forEach((year: any) => { if(Number(year?.PPresAnioMeta) > endYear) valid = false})
          res?.details?.[0]?.years?.forEach((year: any) => { if(Number(year?.PPresAnioMeta) > endYear) valid = false})
        }
      }
    }

    return valid
  }

  public validBeneficiaries() {
    let hasTotalBenef = false
    let data = this.view.step1Data
    if(!Utilities.isNullEmptyObject(data)){
      data?.beneficiaries.forEach((be: any) => { 
        if(Number(be.PPresTotalAnio) > 0 && !hasTotalBenef) hasTotalBenef = true
      })
    }
    return hasTotalBenef
  }
  //#endregion
  /*********************************************** */
  //#region tables
  public initializeStep1() {
    this.getReadOnly();
    if (this.isContentReady) {
      const start = this.currentBudgetStartDate;
      const bsGridProps = this.getBsGridData(this.currentLabels, {
        columns: this.getDataColumnsBS(this.formMasters, this.currentBudget),
        dataSource: this.dataSourceBs(this.formMasters),
        dataSourceColumns: this.getBsPivotDataSource(
          this.currentBudgetStartDate
        ),
        pivotInfo: {
          columnId: Enums.ProaBasicFields.GenericDataId,
          columnName: [Enums.ProaBasicFields.Meta],
          columnValue: [Enums.ProaBasicFields.MetaValor],
          joinTitle: true,
          start: !Utilities.isNullEmptyObject(start)
            ? new Date(start).getFullYear()
            : null,
        },
      });
      const bfGridProps = this.getBfGridData(this.currentLabels, {
        columns: this.getDataColumnsBF(this.formMasters, this.currentBudget),
        dataSource: this.dataSourceBf(this.currentBudgetStartDate),
      });
      bfGridProps.summaryRows = this.getSummaries(bfGridProps.columns.slice(1));
      bsGridProps.readOnly = this.view.state.readOnly || false;
      bfGridProps.readOnly = this.view.state.readOnly || false;

      this.view.state.setFirstDataGridProps(bsGridProps);
      this.view.state.setSecondDataGridProps(bfGridProps);
    }
  }
  //#endregion
  /********************************************** */
  //#region save step 1
  public saveStep1() {
    Utilities.showLoading(this.currentLabels.get("savingMessage"), this.currentLabels.get("loadingMessage"))
    const start = this.currentBudgetStartDate;
    const optionsBs: IDataTable = {
      id: Enums.DataGridId.BaseLineSt1,
      pivotInfo: {
        dataSource: this.getBsPivotDataSource(this.currentBudgetStartDate),
        columnId: Enums.ProaBasicFields.GenericDataId,
        columnName: [Enums.ProaBasicFields.Meta],
        columnValue: [Enums.ProaBasicFields.MetaValor],
        joinTitle: true,
        start: !Utilities.isNullEmptyObject(start)
          ? new Date(start).getFullYear()
          : null,
      },
    };
    const optionsBf: IDataTable = {
      id: Enums.DataGridId.BeneficiariesSt1,
    };
    const dataBs = GridUtilities.getTableData(
      optionsBs,
      Enums.ProaBasicFields.GenericDataId
    );
    const dataBf = GridUtilities.getTableData(
      optionsBf,
      Enums.ProaBasicFields.GenericDataId
    );
    const genericInfo = this.getGenericInfo(dataBs.data, dataBs.grid);
    const beneficiaries = this.getBeneficiaries(dataBf.grid);
    const baseLineYears: Array<ISpfrStep1Anio> = dataBs.pivotData;
    const step1Data: ICmdSpfrStep1 = {
      genericInfo,
      baseLineYears,
      beneficiaries,
      files: this.view.state.files/*.filter((file: IFileDto) =>
        !Utilities.isNullObject(file.fileRelativeUrl)
      ),*/
    };
    
    if (Utilities.isNullEmptyObject(this.view.step1Data)) {
      const title = this.currentLabels.get("Nuevo Registro");
      const msg = this.currentLabels.get("Alerta Nuevo Registro");
      Utilities.showConfirmation(msg, title).then((response) => {
        if (response) {
          this.saveStep_1(step1Data);
          Utilities.showLoading(this.currentLabels.get("savingMessage"), this.currentLabels.get("loadingMessage"))
        }
      });
    } else {      
      this.saveStep_1(step1Data);
    }
  }
  private saveStep_1(data: ICmdSpfrStep1) {
    const stepData = { ...data };
    stepData.baseLineYears = data.baseLineYears.map((x: any) => {
      delete x.rowIndex;
      return x;
    });

    const interventionLine = this.formMasters.interventionLines.find((x: any) => x.Id === this.currentBudget.OCTAVIALineaIntervencionId) || null;
    const country_region = this.currentBudget.OCTAVIAPaisId 
      ? this.formMasters.countries.find((x: any) => x.Id === this.currentBudget.OCTAVIAPaisId)  
      : this.formMasters.regions.find((x: any) => x.Id === this.currentBudget.OCTAVIARegionId);    
    
    let aux = stepData.files.map((file:any)=>{      
      return {
        ...file,
        PPresLineaInter: interventionLine?.Title || null,
        PProaFinanciador: this.view.state.financers,
        PProaPaisRegion: country_region?.Title || null,
        OCTAVIADatosGeneralesCodigoProyecto: this.currentBudget.PPresCodProy
      }        
    });
    stepData.files = aux;    
    let userEmail = this.currentUser.currentUser.userPrincipalName;
    this.SPFRService.saveSPFRStep1(stepData, userEmail)
      .then((data) => {
        const title = this.currentLabels.get("Guardar");
        const msg = this.currentLabels.get("Guardado exitoso");
        this.view.setStep1(undefined)
        this.view.setAlerts(true)
        Utilities.notifySuccess(msg, title).then((x) => {
          this.view.state.handleSwitch?.()
        });
      })
      .catch((error) => {
        this.writeErrorLog(error, stepData).then((guid: string) => {
          Utilities.notifyError(
            String.Format(
              this.currentLabels.get("No se pudo guardar el registro"),
              guid
            )
          );
        });
      });
  }
  private getGenericInfo(bsItems: any[], bsGrid: DataGrid) {
    return {
      OCTAVIAFechaFinalizacion:moment.utc(this.view.state.endDate).tz(Constants.GeneralFormats.TIME_ZONE).format(Constants.GeneralFormats.DATE_FORMAT),
      OCTAVIAFechaInicio: moment.utc(this.currentBudgetStartDate).tz(Constants.GeneralFormats.TIME_ZONE).format(Constants.GeneralFormats.DATE_FORMAT),
      PFFRRLineaBase: bsItems[0].PFFRRLineaBase,
      PProaAnioLineaBase: bsItems[0].PProaAnioLineaBase,
      PPresIndicadorLineaEstrategica1Id: bsGrid.cellValue(0, Enums.ProaBasicFields.IndicadorLE1) ?? null,
      PPresPresupuestoId: this.currentBudget.Id,
      PProaMetaFinal: bsItems[0].PProaMetaFinal,
      PProaUnidadMedida: "",
      Id: bsItems[0].Id,
    };
  }
  private getBeneficiaries(bfGrid: DataGrid) {
    const bfItems = bfGrid.getDataSource().items();
    const beneficiaries: Array<ISpfrStep1Beneficiary> = [];
    bfItems.forEach((item, index) => {
      const newItem: ISpfrStep1Beneficiary = {
        PFFRRTotalHombres: bfGrid.cellValue(
          index,
          Enums.ProaBasicFields.TotalHombres
        ),
        PFRRTotalMujeres: bfGrid.cellValue(
          index,
          Enums.ProaBasicFields.TotalMujeres
        ),
        PPresTotalAnio: bfGrid.cellValue(
          index,
          Enums.ProaBasicFields.TotalMeta
        ),
        PPresuAnio: bfGrid
          .cellValue(index, Enums.ProaBasicFields.BeneficiarioAnio)
          .toString(),
        Id: bfGrid.cellValue(index, Enums.ProaBasicFields.Id),
        PPresPresupuestoId: this.currentBudget.Id.toString(),
      };
      beneficiaries.push(newItem);
    });
    return beneficiaries;
  }
  //#endregion
  /******************************************** */
  //#region Files
  public addFile(object: any) {    
    let existentFiles = this.view.state.files;
    existentFiles.push({
      file: object.file,
      fileName: object.documentName
    } as IFileDto);

    this.view.state.setFile(existentFiles);
    this.openCloseModal();
  }

  public openCloseModal() {
    let openClose = this.view.state.modalOpen ?? false;
    this.view.state.setModalOpen(!openClose);
  }

  public openCloseModalExcel() {
    let openClose = this.view.state.modalExcel ?? false;
    this.view.state.setModalExcel(!openClose);
    this.view.state.setGridDataExcel(null);
  }


  public async deleteDocument(fileName: string) {
    let file = this.view.state.files.find(
      (file: IFileDto) => file.fileName === fileName
    );

    if (!Utilities.isNullObject(file.fileRelativeUrl)) {
      Utilities.showConfirmation(
        this.currentLabels.get("proaDocumentoEliminarMensaje"),
        this.currentLabels.get("proaDocumentoEliminarTitulo"),
        this.currentLabels.get("proaDocumentoEliminarBoton"),
        this.currentLabels.get("Cancelar")
      ).then(async (response: boolean) => {
        if (response) {
          this.dispatcherProgress(0);
          this.dispatcherPendingLoad(1);
          this.dispatcherSetLoading();
          try {
            this.dispatcherProgress(20);
            await this.proaService.deleteFile(file.fileRelativeUrl);
            this.dispatcherProgress(50);
            let files = this.view.state.files.filter(
              (file: IFileDto) => file.fileName !== fileName
            );
            this.view.state.setFile(files);
            this.dispatcherProgress(99);
            this.dispatcherUnsetSetLoading();
            Utilities.notifySuccess(
              this.currentLabels.get("proaDocumentoEliminarSuccess"),
              this.currentLabels.get("proaDocumentoEliminarTitulo")
            );
          } catch (error) {
            this.dispatcherProgress(50);
            this.dispatcherUnsetSetLoading();
            this.writeErrorLog(error as Error, { fileName }).then((guid: string) => {
              Utilities.notifyError(
                String.Format(
                  "{0} - {1}",
                  this.currentLabels.get("proaDocumentoEliminarFail"),
                  guid
                )
              );
            });
          }
        }
      });
    } else {
      Utilities.showConfirmation(
        this.currentLabels.get("proaDocumentoEliminarMensaje"),
        this.currentLabels.get("proaDocumentoEliminarTitulo"),
        this.currentLabels.get("proaDocumentoEliminarBoton"),
        this.currentLabels.get("Cancelar")
      ).then(async (response: boolean) => {
        if (response) {
          try {
            let files = this.view.state.files.filter(
              (file: IFileDto) => file.fileName !== fileName
            );
            this.view.state.setFile(files);
            Utilities.notifySuccess(
              this.currentLabels.get("proaDocumentoEliminarSuccess"),
              this.currentLabels.get("proaDocumentoEliminarTitulo")
            );
          } catch (error) {
            Utilities.notifyError(
              this.currentLabels.get("proaDocumentoEliminarFail"),
              this.currentLabels.get("proaDocumentoEliminarTitulo")
            );
          }
        }
      });
    }
  }

  //#endregion
  /********************************************* */
  //#region Step2
  public async initStep2() {
    return await this.getSpfrStep2();
  }

  public initializeStep2() {
    this.getReadOnly();
    if (this.isContentReady) {
      const start = this.currentBudgetStartDate;
      const impGridProps = this.getImpGridData(this.currentLabels, {
        columns: this.getDataColumnsImplementers(
          this.formMasters,
          this.currentBudget,
          this.currentBudgetDetails
        ),
        dataSource: this.dataSourceImp(),
        dataSourceColumns: this.getImpPivotDataSource(
          this.currentBudgetStartDate
        ),
        pivotInfo: {
          columnId: Enums.ProaBasicFields.GenericDataId2,
          columnName: [Enums.ProaBasicFields.Meta],
          columnValue: [Enums.ProaBasicFields.MetaValor],
          joinTitle: false,
          start: !Utilities.isNullEmptyObject(start) ? new Date(start).getFullYear() : null,
        },
      });
      impGridProps.summaryRows = this.getSummaries(impGridProps.columns.slice(2));
      delete impGridProps.gridProps.stateStoring
      this.view.state.setFirstDataGridProps(impGridProps);
    }
  }
  //#region save step 2
  public saveStep2() {
    Utilities.showLoading(this.currentLabels.get("savingMessage"), this.currentLabels.get("loadingMessage"))
    const start = this.currentBudgetStartDate;
    const optionsImp: IDataTable = {
      id: Enums.DataGridId.ImplementersSt2,
      pivotInfo: {
        dataSource: this.getImpPivotDataSource(this.currentBudgetStartDate),
        columnId: Enums.ProaBasicFields.GenericDataId2,
        columnName: [Enums.ProaBasicFields.Meta],
        columnValue: [Enums.ProaBasicFields.MetaValor],
        joinTitle: false,
        start: !Utilities.isNullEmptyObject(start)
          ? new Date(start).getFullYear()
          : null,
      },
    };
    
    const dataIm = GridUtilities.getTableData(
      optionsImp,
      Enums.ProaBasicFields.GenericDataId2
    );
    let msgAlert = false;
    const genericInfo: Array<IDtoStep2> = dataIm.data.map((x, i) => {
      if (x.OCTAVIASLEPId !== null && !Utilities.isNullEmptyObject(x.OCTAVIASLEPId[0])) {
        const implementerYears: Array<ISpfrStep2Anio> = dataIm.pivotData
          .filter((y) => y.rowIndex === i)
          .map((y: any) => {
            delete y.rowIndex;
            return y;
          });
        const basicInfo: ISpfrStep2 = {
          Id: x.Id || 0,
          OCTAVIASLEPId: x.OCTAVIASLEPId[0] || null,
          PPresPresupuestoId: this.currentBudget.Id,
          PProaImplementadorTotal: dataIm.grid.cellValue(
            i,
            Enums.ProaBasicFields.TotalImplementadores
          ),
        };
        return { basicInfo, implementerYears };
      }
      msgAlert = true;
    });
    const step2Data: ICmdSpfrStep2Update = {
      budgetId: this.currentBudget.Id,
      genericInfo: genericInfo.filter((x) => !Utilities.isNullEmptyObject(x)),
      genericInfoToDelete: [],
    };
    if (msgAlert) {
      const title = this.currentLabels.get("alertMsgLocationTitle");
      const msg = this.currentLabels.get("alertMsgLocation");
      Utilities.showConfirmation(msg, title).then((response) => {
        if (response) {
          this.saveStep_2(step2Data);
          Utilities.showLoading(this.currentLabels.get("savingMessage"), this.currentLabels.get("loadingMessage"))
        } 
      });
    } else {
      this.saveStep_2(step2Data);
    }
  }
  private saveStep_2(step2Data: ICmdSpfrStep2Update) {
    this.SPFRService.saveSPFRStep2(step2Data)
      .then((data) => {
        const title = this.currentLabels.get("Guardar");
        const msg = this.currentLabels.get("Guardado exitoso");
        this.view.setStep2(undefined)
        Utilities.notifySuccess(msg, title).then((x) => {
          this.view.state.handleSwitch?.()
        });
      })
      .catch((error) => {
        this.writeErrorLog(error, step2Data).then((guid: string) => {
          Utilities.notifyError(
            String.Format(
              this.currentLabels.get("No se pudo guardar el registro"),
              guid
            )
          );
        });
      });
  }
  //#endregion
  /********************************************* */
  //#endregion
  /********************************************* */
  //#region Step3
  public async initStep3() {
    return await this.getSpfrStep3();
  }

  public initializeStep3() {
    this.getReadOnly();
    if (this.isContentReady) {
      const start = this.currentBudgetStartDate;
      const locGridProps = this.getLocGridData(this.currentLabels, {
        columns: this.getDataColumnsLocation(
          this.formMasters,
          this.currentBudget,
          this.currentBudgetDetails
        ),
        dataSource: this.dataSourceLoc(),
        dataSourceColumns: this.getLocPivotDataSource(
          this.currentBudgetStartDate
        ),
        pivotInfo: {
          columnId: Enums.ProaBasicFields.GenericDataId3,
          columnName: [Enums.ProaBasicFields.Meta],
          columnValue: [Enums.ProaBasicFields.MetaValor],
          joinTitle: false,
          start: !Utilities.isNullEmptyObject(start)
            ? new Date(start).getFullYear()
            : null,
        },
      });
      locGridProps.summaryRows = this.getSummaries(
        locGridProps.columns.slice(2)
      );
      const adtGridProps = this.getAdtGridData(this.currentLabels, {
        columns: this.getDataColumnsADT(this.formMasters, this.currentBudget, this.currentBudgetDetails),
        dataSource: this.dataSourceAdt(),
        dataSourceColumns: this.getAdtPivotDataSource(
          this.currentBudgetStartDate
        ),
        pivotInfo: {
          columnId: Enums.ProaBasicFields.GenericDataId3,
          columnName: [Enums.ProaBasicFields.Meta],
          columnValue: [Enums.ProaBasicFields.MetaValor],
          joinTitle: false,
          start: !Utilities.isNullEmptyObject(start)
            ? new Date(start).getFullYear()
            : null,
        },
      });
      adtGridProps.summaryRows = this.getSummaries(
        adtGridProps.columns.slice(2)
      );
      this.view.state.setFirstDataGridProps(locGridProps);
      this.view.state.setSecondDataGridProps(adtGridProps);
    }
  }
  /********************************************* */
  //#region save step 3
  public saveStep3() {
    Utilities.showLoading(this.currentLabels.get("savingMessage"), this.currentLabels.get("loadingMessage"))
    const start = this.currentBudgetStartDate;
    const optionsLoc: IDataTable = {
      id: Enums.DataGridId.LocationsSt3,
      pivotInfo: {
        dataSource: this.getLocPivotDataSource(this.currentBudgetStartDate),
        columnId: Enums.ProaBasicFields.GenericDataId3,
        columnName: [Enums.ProaBasicFields.Meta],
        columnValue: [Enums.ProaBasicFields.MetaValor],
        joinTitle: false,
        start: !Utilities.isNullEmptyObject(start)
          ? new Date(start).getFullYear()
          : null,
      },
    };
    const optionsADT: IDataTable = {
      id: Enums.DataGridId.AdtsSt3,
      pivotInfo: {
        dataSource: this.getAdtPivotDataSource(this.currentBudgetStartDate),
        columnId: Enums.ProaBasicFields.GenericDataId3,
        columnName: [Enums.ProaBasicFields.Meta],
        columnValue: [Enums.ProaBasicFields.MetaValor],
        joinTitle: false,
        start: !Utilities.isNullEmptyObject(start)
          ? new Date(start).getFullYear()
          : null,
      },
    };
    const dataZC = GridUtilities.getTableData(optionsLoc, "PProaFRStep3Id");
    const dataAd = GridUtilities.getTableData(optionsADT, "PProaFRStep3Id");
    let adtAlert = false;
    let zonesAlert = false;
    const zones: Array<IDtoAdtZonaSave> = dataZC.data.map((x, i) => {
      if (!Utilities.isNullEmptyObject(x.PProaLocationId?.[0])) {
        const details: Array<ISpfrStep3Anios> = dataZC.pivotData
          .filter((y) => y.rowIndex === i)
          .map((j: any) => {
            delete j.rowIndex;
            return j;
          });
        const genericInfo: ISpfrStep3 = {
          Id: x.Id || 0,
          PProaLocationId: x.PProaLocationId[0] || null,
          PProaAdtId: null,
          PPresPresupuestoId: this.currentBudget.Id,
          PFFRRTotal: dataZC.grid.cellValue(
            i,
            Enums.ProaBasicFields.TotalADTLOC
          ),
        };
        return { details, genericInfo };
      }
      zonesAlert = true;
    });
    const adts: Array<IDtoAdtZonaSave> = dataAd.data.map((x, i) => {
      if (!Utilities.isNullEmptyObject(x.PProaAdtId?.[0])) {
        const details: Array<ISpfrStep3Anios> = dataAd.pivotData
          .filter((y) => y.rowIndex === i)
          .map((j: any) => {
            delete j.rowIndex;
            return j;
          });
        const genericInfo: ISpfrStep3 = {
          Id: x.Id || 0,
          PProaLocationId: null,
          PProaAdtId: x.PProaAdtId[0] || null,
          PPresPresupuestoId: this.currentBudget.Id,
          PFFRRTotal: dataAd.grid.cellValue(
            i,
            Enums.ProaBasicFields.TotalADTLOC
          ),
        };
        return { details: details, genericInfo: genericInfo };
      }
      adtAlert = true;
    });
    const step3Data: ICmdSpfrStep3Update = {
      budgetId: this.currentBudget.Id,
      adts: adts.filter((x) => !Utilities.isNullEmptyObject(x)),
      adtsToDelete: [],
      zones: zones.filter((x) => !Utilities.isNullEmptyObject(x)),
      zonesToDelete: [],
    };
    if (adtAlert || zonesAlert) {
      const title = this.currentLabels.get("alertMsgLocationTitle");
      const msg = this.currentLabels.get("alertMsgLocation");
      Utilities.showConfirmation(msg, title).then((response) => {
        if (response) {
          this.saveStep_3(step3Data);
          Utilities.showLoading(this.currentLabels.get("savingMessage"), this.currentLabels.get("loadingMessage"))
        }
      });
    } else {
      this.saveStep_3(step3Data);
    }
  }
  private saveStep_3(step3Data: ICmdSpfrStep3Update) {
    this.SPFRService.saveSPFRStep3(step3Data)
      .then((data) => {
        const title = this.currentLabels.get("Guardar");
        const msg = this.currentLabels.get("Guardado exitoso");
        this.view.setStep3(undefined)
        Utilities.notifySuccess(msg, title).then((x) => {
          this.view.state.handleSwitch?.()
        });
      })
      .catch((error) => {
        this.writeErrorLog(error, step3Data).then((guid: string) => {
          Utilities.notifyError(
            String.Format(
              this.currentLabels.get("No se pudo guardar el registro"),
              guid
            )
          );
        });
      });
  }
  //#endregion

  public onCellPreRender(data: any,column: BatchGridColumnProps): BatchGridColumnProps {
    const newColumn: BatchGridColumnProps = { ...column };
    if (
      column.dataField === Enums.ProaBasicFields.IndicadorProducto &&
      !Utilities.isNullEmptyObject(data.data.PFFRRCodigoProductoId)
    ) {
      const codProd = data.data.PFFRRCodigoProductoId[0];
      const items = this.formMasters.productsIndicators.filter(
        (x: any) => x.PFFRRCodigoProductoId === codProd
      );
      newColumn.items = Utilities.processDropDownData(
        items,
        Enums.ListTypes.ProductsIndicator
      );
      newColumn.readOnly = false;
    }

    if(column.dataField === Enums.ProaBasicFields.PProaMedidaId){
      let items = Utilities.processDropDownData(this.formMasters.measureUnits.filter((x: any) => (x.OCTAVIAActivo)), Enums.ListTypes.MeasureUnits);
      let allItems = Utilities.processDropDownData(this.formMasters.measureUnits, Enums.ListTypes.MeasureUnits);

      newColumn.items = items;
      newColumn.allItems = allItems;
    }

    if(column.dataField === Enums.ProaBasicFields.IndicadorLE1){
      let auxItems = Utilities.processDropDownData(this.formMasters.strategicLines.filter((x: any) => (x.OCTAVIAActivo)), Enums.ListTypes.StrategicLine);
      let newItems: any[] = []

      if(column.items?.length){
        column.items.forEach(x => {
          let findItem = auxItems.find((y: any) => y.id === x.id)
          if(findItem) newItems.push(x)
        })
      }

      newColumn.allItems = column.items;
      newColumn.items = newItems;
    }

    if (column.dataField === Enums.ProaBasicFields.PProaTipoContrapartida ) {
      data.data.IdContrapartida = [];
      const items = this.formMasters.counterpartType.filter((x: any) => x.ActivoFR);
      newColumn.items = Utilities.processDropDownData(
        items,
        Enums.ListTypes.ProaTipoContrapartida
      );
    }

    if (column.dataField === Enums.ProaBasicFields.IdContrapartida ) {
        newColumn.acceptCustomValue = false;
        let items: any[] = [];
        let prefix: string = "";

        if(data?.data?.PProaTipoContrapartida){
          let typeId = data?.data?.PProaTipoContrapartida[0]

          switch (typeId) {
            case 1:
              items = this.formMasters.ffrrFinancer.filter((x: any) => (x.OCTAVIAActivo))
              prefix = "FIN"
              break;
            case 4:
              if(this.view.implementersData){
                let arrayExcluded = this.params[Enums.Params.impCodesExcludedCounterpart]?.split(',') || [];
                this.view.implementersData.genericInfo.forEach((x: any) => {
                  if(x.basicInfo.OCTAVIASLEP){
                    let impData = this.formMasters.implementators.find((y: any) => (x.basicInfo.OCTAVIASLEP.Id === y.Id && y.OCTAVIAActivo));
                    if(!arrayExcluded.includes(impData?.OCTAVIACodigo) && impData)
                      items.push({ ID: x.basicInfo.OCTAVIASLEP.Id, Title: x.basicInfo.OCTAVIASLEP.Title })
                  }
                });
              }
              prefix = "IMP"
              break;
          case 5:
            newColumn.acceptCustomValue = true;
            if(data.value?.length){
              const newItem = {
                Title: data.value[0].slice(3),
                ID: data.value[0]
              };
              items = [newItem]
            }
            break;
        }
      }

      newColumn.items = Utilities.processDropDownData(
        items,
        Enums.ListTypes.ProaSubproyectoFRStepSDC,
        "",
        prefix
      );
    }
    return newColumn;
  }

  //#endregion
  /***************************************************** */
  //#region forms
  
  //#endregion
  /********************************************* */
  //#region Step 5 
  public initSummaryStep2() {
    if (this.isContentReady) {
      const impGridProps = this.getImplementersSummary();
      this.view.state.setFirstDataGridProps(impGridProps);
    }
  }
  public initSummaryStep3() {
    if (this.isContentReady) {
      const locGridProps = this.getLocationsSummary();
      this.view.state.setSecondDataGridProps(locGridProps);

      const adtProps = this.getAdtsSummary();
      this.view.state.setFifthDataGridProps(adtProps);
    }
  }
  public initSummaryStepSDC() {
    if (this.isContentReady) {
      const sdcGridProps = this.getCounterpartsSummary();
      this.view.state.setFourthDataGridProps(sdcGridProps);
    }
  }
  public initSummaryStep4() {
    if (this.isContentReady) {
      const actGridProps = this.getActivitiesSummary();
      this.view.state.setThirdDataGridProps(actGridProps);

      const sumActGridProps = this.getActivitiesSummary2();
      this.view.state.setSixthDataGridProps(sumActGridProps);
    }
  }
  //#endregion
  /********************************************* */
  //#region StepSDC
  public async initStepSDC() {
    return await this.getSpfrStepSDC();
  }

  public initializeStepSDC() {
    this.getReadOnly();
    if (this.isContentReady && !Utilities.isNullEmptyObject(this.view.state.dataColumns)) {
      const start = this.currentBudgetStartDate;
      const contrapartidasGridProps = this.getSDCGridData(this.currentLabels, {
        columns: this.getDataColumnsCounterparts(
          this.formMasters,
          this.currentBudget,
        ),
        dataSource: this.dataSourceSDC(),
        dataSourceColumns: this.getSDCPivotDataSource(
          this.currentBudgetStartDate
        ),
        pivotInfo: {
          columnId: Enums.ProaBasicFields.GenericDataIdSDC,
          columnName: [Enums.ProaBasicFields.Meta],
          columnValue: [Enums.ProaBasicFields.MetaValor],
          joinTitle: false,
          start: !Utilities.isNullEmptyObject(start) ? new Date(start).getFullYear() : null,
        },
        gridProps:{ wordWrapEnabled: true }
      });
      contrapartidasGridProps.summaryRows = this.getSummaries(contrapartidasGridProps.columns.slice(3));
      delete contrapartidasGridProps.gridProps.stateStoring
      this.view.state.setFirstDataGridProps(contrapartidasGridProps);
    }
  }
  //#region save step SDC
  public saveStepSDC() {
    Utilities.showLoading(this.currentLabels.get("savingMessage"), this.currentLabels.get("loadingMessage"))
    const start = this.currentBudgetStartDate;
    const optionsSDC: IDataTable = {
      id: String.Format(Enums.DataGridId.CounterpartsStSDC, "ffrr"),
      pivotInfo: {
        dataSource: this.getSDCPivotDataSource(this.currentBudgetStartDate),
        columnId: Enums.ProaBasicFields.GenericDataIdSDC,
        columnName: [Enums.ProaBasicFields.Meta],
        columnValue: [Enums.ProaBasicFields.MetaValor],
        joinTitle: false,
        start: !Utilities.isNullEmptyObject(start)
          ? new Date(start).getFullYear()
          : null,
      },
    };

    const dataSDC = GridUtilities.getTableData(
      optionsSDC,
      Enums.ProaBasicFields.GenericDataIdSDC
    );
    console.log("datasdcdata",dataSDC.data);
    let msgAlert = false;
    const genericInfo: Array<IDtoStepSDC> = dataSDC.data.map((x, i) => {
      if (!Utilities.isNullEmptyObject(x.IdContrapartida[0])) {
        let type: string = x.IdContrapartida[0].substring(0,3);
        let value = (type !== "NEW") ? parseInt(x.IdContrapartida[0].slice(3)) : x.IdContrapartida[0].slice(3);
        const counterpartYears: Array<ISpfrStepSDCAnio> = dataSDC.pivotData
          .filter((y) => y.rowIndex === i)
          .map((y: any) => {
            delete y.rowIndex;
            return y;
          });
        const basicInfo: ISpfrStepSDC = {
          Id: x.Id || 0,
          PPresPresupuestoId: this.currentBudget.Id,
          OCTAVIAFinanciadorSapId: type === "FIN" ? value : null,
          OCTAVIACodigoFinanciacionId: type === "COD" ? value : null,
          OCTAVIASLEPId: type === "IMP" ? value : null,
          PProaTipoContrapartidaId: x.PProaTipoContrapartida[0],
          Title: type === "NEW" ? value : String.Empty,
        };
        return { basicInfo, counterpartYears };
      }
      msgAlert = true;
    });
    const stepSDCData: ICmdSpfrStepSDCUpdate = {
      budgetId: this.currentBudget.Id,
      genericInfo: genericInfo.filter((x) => !Utilities.isNullEmptyObject(x)),
      genericInfoToDelete: [],
    };
    if (msgAlert) {
      const title = this.currentLabels.get("alertMsgLocationTitle");
      const msg = this.currentLabels.get("alertMsgLocation");
      Utilities.showConfirmation(msg, title).then((response) => {
        if (response) {
          this.saveStep_SDC(stepSDCData);
          Utilities.showLoading(this.currentLabels.get("savingMessage"), this.currentLabels.get("loadingMessage"))
        }
      });
    } else {
      this.saveStep_SDC(stepSDCData);
    }
  }
  private saveStep_SDC(stepSDCData: ICmdSpfrStepSDCUpdate) {
    let userEmail = this.currentUser.currentUser.userPrincipalName;
    this.SPFRService.saveSPFRStepSDC(stepSDCData, userEmail)
      .then((data) => {
        const title = this.currentLabels.get("Guardar");
        const msg = this.currentLabels.get("Guardado exitoso");
        this.view.setStepSDC(undefined)
        Utilities.notifySuccess(msg, title).then((x) => {
          this.view.state.handleSwitch?.()
        });
      })
      .catch((error) => {
        this.writeErrorLog(error, stepSDCData).then((guid: string) => {
          Utilities.notifyError(
            String.Format(
              this.currentLabels.get("No se pudo guardar el registro"),
              guid
            )
          );
        });
      });
  }
  //#endregion
  /********************************************* */
  private getImplementersSummary() {
    const start = this.currentBudgetStartDate;
    const impGridProps = this.getSummaryGridData(this.currentLabels, {
      columns: this.getDataColumnsImplementers(this.formMasters, this.currentBudget, this.currentBudgetDetails),
      dataSource: this.dataSourceImp(),
      dataSourceColumns: this.getImpPivotDataSource(this.currentBudgetStartDate),
      pivotInfo: {
        columnId: Enums.ProaBasicFields.GenericDataId2,
        columnName: [Enums.ProaBasicFields.Meta],
        columnValue: [Enums.ProaBasicFields.MetaValor],
        joinTitle: false,
        start: !Utilities.isNullEmptyObject(start) ? new Date(start).getFullYear() : null,
      },
    },
    Enums.DataGridId.ImplementersSummary, "Implementadores");
    const newColumns = impGridProps.columns.slice(2);
    const sumItem: any = {};

    newColumns.forEach((column: any, i: number) => {
      if (i < newColumns.length ) {
        sumItem[column.dataField] = this.dataSourceSummary( impGridProps.dataSource, column.dataField);
      }
    });
    impGridProps.columns = newColumns;
    impGridProps.dataSource = [sumItem];
    delete impGridProps.gridProps.stateStoring;
    return impGridProps;
  }
  private getCounterpartsSummary() {
    const start = this.currentBudgetStartDate;
    const sdcGridProps = this.getSummaryGridData(this.currentLabels, {
      columns: this.getDataColumnsCounterparts( this.formMasters, this.currentBudget),
      dataSource: this.dataSourceSDC(),
      dataSourceColumns: this.getSDCPivotDataSource(this.currentBudgetStartDate),
      pivotInfo: {
        columnId: Enums.ProaBasicFields.GenericDataIdSDC,
        columnName: [Enums.ProaBasicFields.Meta],
        columnValue: [Enums.ProaBasicFields.MetaValor],
        joinTitle: false,
        start: !Utilities.isNullEmptyObject(start) ? new Date(start).getFullYear() : null,
      },
    },
    String.Format(Enums.DataGridId.CounterpartsStSDCSummary, "ffrr"), "PProaContrapartidas");
    const newColumns = sdcGridProps.columns.slice(3);
    const sumItem: any = {};
    newColumns.forEach((column: any, i: number) => {
      if (i < newColumns.length) {
        sumItem[column.dataField] = this.dataSourceSummary( sdcGridProps.dataSource, column.dataField);
      }
    });
    sdcGridProps.columns = newColumns;
    sdcGridProps.dataSource = [sumItem];
    delete sdcGridProps.gridProps.stateStoring;
    return sdcGridProps;
  }
  private getLocationsSummary() {
    const start = this.currentBudgetStartDate;
    const locGridProps = this.getSummaryGridData(
      this.currentLabels,
      {
        columns: this.getDataColumnsLocation(
          this.formMasters,
          this.currentBudget,
          this.currentBudgetDetails
        ),
        dataSource: this.dataSourceLoc(),
        dataSourceColumns: this.getLocPivotDataSource(this.currentBudgetStartDate),
        pivotInfo: {
          columnId: Enums.ProaBasicFields.GenericDataId3,
          columnName: [Enums.ProaBasicFields.Meta],
          columnValue: [Enums.ProaBasicFields.MetaValor],
          joinTitle: false,
          start: !Utilities.isNullEmptyObject(start) ? new Date(start).getFullYear() : null,
        },
      },
      Enums.DataGridId.LocationsSummary, "ZONACCAA"
    );
    const newColumnsLoc = locGridProps.columns.slice(2);
    const sumItemLoc: any = {};
    newColumnsLoc.forEach((column: any, index: number) => {
      if (index < newColumnsLoc.length) {
        sumItemLoc[column.dataField] = this.dataSourceSummary(locGridProps.dataSource, column.dataField);
      }
    });
    locGridProps.columns = newColumnsLoc;
    locGridProps.dataSource = [sumItemLoc];

    return locGridProps;
  }
  private getAdtsSummary() {
    const start = this.currentBudgetStartDate;
    const adtGridProps = this.getSummaryGridData(
      this.currentLabels,
      {
        columns: this.getDataColumnsADT(
          this.formMasters,
          this.currentBudget,
          this.currentBudgetDetails
        ),
        dataSource: this.dataSourceAdt(),
        dataSourceColumns: this.getAdtPivotDataSource(this.currentBudgetStartDate),
        pivotInfo: {
          columnId: Enums.ProaBasicFields.GenericDataId3,
          columnName: [Enums.ProaBasicFields.Meta],
          columnValue: [Enums.ProaBasicFields.MetaValor],
          joinTitle: false,
          start: !Utilities.isNullEmptyObject(start) ? new Date(start).getFullYear() : null,
        },
      },
      Enums.DataGridId.AdtsSummary, "ADT"
    );
    const newColumnsAdt = adtGridProps.columns.slice(2);
    const sumItemAdt: any = {};
    newColumnsAdt.forEach((column: any, index: number) => {
      if (index < newColumnsAdt.length) {
        sumItemAdt[column.dataField] = this.dataSourceSummary(adtGridProps.dataSource, column.dataField);
      }
    });
    adtGridProps.columns = newColumnsAdt;
    adtGridProps.dataSource = [sumItemAdt];
    return adtGridProps;
  }
  private getActivitiesSummary() {
    const actGridPropsData: any = {};
    actGridPropsData.columns = this.getDataColumnsSummaryActivities(
      this.formMasters,
      this.currentBudget,
      this.currentLabels
    );
    actGridPropsData.dataSource = this.getActSummaryDataSource(
      this.view.state.step4 || []
    );
    actGridPropsData.summaryRows = [{
      column: actGridPropsData.columns.slice(-1)[0].title,
      summaryType: "sum",
      valueFormat: Constants.GeneralFormats.CURRENCY_FORMAT,
    }];
    actGridPropsData.gridProps = {
      filterPanel: { visible: false },
      groupPanel: { visible: true },
      showHeaderFilter: true,
      columnChooser: { allowSearch: true, enabled: true, mode: "select" },
      headerFilter: { visible: true, allowSearch: true },
    };
    const actGridProps = this.getSummaryGridData(
      this.currentLabels,
      actGridPropsData,
      String.Format(Enums.DataGridId.ActivitiesSummary, "-1"), "Actividades");
    return actGridProps;
  }
  private getActivitiesSummary2() {
    const start = this.currentBudgetStartDate;
    const actGridPropsData: any = {};
    actGridPropsData.columns = this.getSumActivityColumns(
      this.formMasters,
      this.currentBudget,
      this.currentLabels
    );
    actGridPropsData.dataSource = this.dataSourceSumActivities();
    actGridPropsData.dataSourceColumns = this.getSumActivityPivotDataSource(this.currentBudgetStartDate);
    actGridPropsData.pivotInfo = {
      columnId: Enums.ProaBasicFields.PProaFEStep4ActividadId,
      columnName: [
        Enums.ProaBasicFields.Meta,
        Enums.ProaBasicFields.SubTotal,
      ],
      columnValue: [
        Enums.ProaBasicFields.MetaValor,
        Enums.ProaBasicFields.SubTotal,
      ],
      start: !Utilities.isNullEmptyObject(start) ? new Date(start).getFullYear() : null,
    }
    const actGridProps = this.getSummaryGridData(
      this.currentLabels,
      actGridPropsData,
      String.Format(Enums.DataGridId.ActivitiesSummary, "-11"), "Actividades"
    );

    const newColumnsAdt = actGridProps.columns
    const sumItemAdt: any = {};
    newColumnsAdt.forEach((column: any, index: number) => {
      if (index < newColumnsAdt.length) {
        sumItemAdt[column.dataField] = this.dataSourceSummary(actGridProps.dataSource, column.dataField);
      }
    });
    actGridProps.columns = newColumnsAdt;
    actGridProps.dataSource = [sumItemAdt];

    return actGridProps;
  }

  public onCellPreRenderMri(
    e: any,
    column: BatchGridColumnProps
  ): BatchGridColumnProps {
    const newColumn: BatchGridColumnProps = { ...column };

    let idStrategicLineStep1 = this.view.state.step1?.genericInfo?.PPresIndicadorLineaEstrategica1Id;

    if (column.dataField === Enums.ProaBasicFields.PProaMRIPriority) {
      const allItems = [
        ...Utilities.processDropDownData(this.formMasters.strategicLines.filter((x: any) => x.Id !== idStrategicLineStep1), "", "", Constants.Globals.PREFIX_STRATEGIC_LINE_INDICATOR),
        ...Utilities.processDropDownData(this.formMasters.intermediateResultsIndicator, "", "", Constants.Globals.PREFIX_INTERMEDIATE_RESULTS),
        ...Utilities.processDropDownData(this.formMasters.productsIndicators, "", "", Constants.Globals.PREFIX_PRODUCT_INDICATOR),
      ];

      const items = [
        ...Utilities.processDropDownData(this.formMasters.strategicLines.filter((x: any) => (x.Id !== idStrategicLineStep1 && x.OCTAVIAActivo)), "", "", Constants.Globals.PREFIX_STRATEGIC_LINE_INDICATOR),
        ...Utilities.processDropDownData(this.formMasters.intermediateResultsIndicator.filter((x: any) => (x.OCTAVIAActivo)), "", "", Constants.Globals.PREFIX_INTERMEDIATE_RESULTS),
        ...Utilities.processDropDownData(this.formMasters.productsIndicators.filter((x: any) => (x.OCTAVIAActivo)), "", "", Constants.Globals.PREFIX_PRODUCT_INDICATOR),
      ];

      newColumn.items = items;
      newColumn.allItems = allItems;
    }
    return newColumn;
  }
  //#endregion
}
